module.exports = __webpack_public_path__ + "img/can9.48e2ffa9.png";